// next-i18next(Pages Router) 설정 공장. 앱은 데이터(언어·네임스페이스·폴백)만 넘기고,
// 모양·공통 기본값은 여기 한 곳이 책임진다. CommonJS — next.config.js 가 require 한다.
// 소비: web·zepx·quiz·auth·edit 의 next-i18next.config.js

/**
 * @param {{
 *   locales: readonly string[],
 *   defaultLocale: string,
 *   ns?: readonly string[],
 *   defaultNS?: string,
 *   fallbackLng: string | false,
 *   localePath: string | null,
 *   localeDetection?: boolean,
 *   returnEmptyString?: boolean,
 *   partialBundledLanguages?: boolean,
 *   reloadOnPrerender?: boolean,
 *   resources?: Record<string, Record<string, unknown>>,
 * }} options
 * @returns {import('next-i18next').UserConfig}
 */
function createNextI18nextConfig(options) {
  const {
    locales,
    defaultLocale,
    ns,
    defaultNS,
    fallbackLng,
    localePath,
    localeDetection,
    returnEmptyString,
    partialBundledLanguages,
    reloadOnPrerender,
    resources,
  } = options;

  return {
    // localeDetection 은 Next 라우터 옵션(미지정=true). 생략한 앱은 그대로 둔다.
    i18n: {
      defaultLocale,
      locales: [...locales],
      ...(localeDetection !== undefined && { localeDetection }),
    },
    // ns 를 안 주면 next-i18next 가 localePath 폴더에서 찾는다(quiz 는 페이지마다 고른다).
    ...(ns !== undefined && { ns: [...ns] }),
    ...(defaultNS !== undefined && { defaultNS }),
    supportedLngs: [...locales],
    fallbackLng,
    // 번역 값은 React 가 이스케이프하므로 i18next 가 또 하면 `&amp;` 가 보인다.
    interpolation: { escapeValue: false },
    // 설정은 _app 이 appWithTranslation 에 직접 넘긴다. pageProps 에 실으면 전 페이지 HTML 이 커진다.
    serializeConfig: false,
    localePath,
    ...(returnEmptyString !== undefined && { returnEmptyString }),
    ...(partialBundledLanguages !== undefined && { partialBundledLanguages }),
    ...(reloadOnPrerender !== undefined && { reloadOnPrerender }),
    ...(resources !== undefined && { resources }),
  };
}

module.exports = { createNextI18nextConfig };
